import { useCallback, useEffect, useMemo, useState } from "react";
import { createSessionStorageKeyJSON } from "utils/sessionStorage";
import { AppliedFilter } from "./utils";

const SESSION_FILTERS_PREFIX = "tableFilters";

type Options = {
  sessionKey?: string;
};

function getSessionStorageKey(sessionKey: string) {
  return createSessionStorageKeyJSON<AppliedFilter[]>(
    `${SESSION_FILTERS_PREFIX}:${sessionKey}`,
  );
}

export default function useSessionAppliedFilters({ sessionKey }: Options = {}) {
  const storageKey = useMemo(() => {
    if (!sessionKey) return null;
    return getSessionStorageKey(sessionKey);
  }, [sessionKey]);

  const [sessionFilters, setSessionFilters] = useState<
    AppliedFilter[] | null | undefined
  >(undefined);

  useEffect(() => {
    if (!storageKey) {
      setSessionFilters(undefined);
      return;
    }

    setSessionFilters(storageKey.get() ?? null);
  }, [storageKey]);

  const persistSessionFilters = useCallback(
    (filters: AppliedFilter[]) => {
      if (!storageKey) return;
      storageKey.set(filters);
      setSessionFilters(filters);
    },
    [storageKey],
  );

  const isSessionFiltersReady = !sessionKey || sessionFilters !== undefined;

  return {
    isSessionFiltersReady,
    sessionFilters,
    persistSessionFilters,
  };
}
